module.exports = __webpack_public_path__ + "static/img/semi_green_info_01_logo.017e18bd.png";